import React from 'react';
import {SvgPdf, SvgVideo, SvgPage} from  '../Svg.js'
import { Link } from 'react-router-dom';


const VideoIlustrativo = () => {
	return (
	<tr class="trsegc">
	<td >
	<Link to="/video6"><SvgVideo/></Link>
	</td>
	<td>
		<Link to="/video6">
		<p>
		Veja o video ilustrativo.
		</p>
		</Link>
	</td>
</tr>
)};	




const Segmentos = () => {
  return (
  
<div>
  <div id="titulo">
	<h1>Segmentos</h1>
  </div>	
  <div id = "texto2" class='row'>
		<div class='col-4'>
			<div class='card1'>
				<h2>Alimentação e Bebidas</h2>
				<p>Padarias, Café, Doces e Bolos, Restaurantes, <br/> Pizzarias, Sorveteria e Loja de Vinhos.</p>

				<h6>Programas e Sistemas:</h6>
				<p>PDV, Retaguarda, Emissores Fiscais.</p>
				<p> Painel de Informação, Balança e Micro Terminais.</p>
				<VideoIlustrativo/>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Supermercados</h2>
				<p>Mercados, Minimercados, Hortifrúti, Açougues, Peixaria e Material de Construção.</p>
				<h6>Programas e Sistemas:</h6>
				<p>PDV, Retaguarda, Emissores Fiscais.</p>
				<p> Painel de Informação, Balança e Consulta Preço.</p>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Beleza e Saúde</h2>
				<p>Estética, Perfumes e  Cosméticos.</p>
				<h6>Programas e Sistemas:</h6>
				<p>PDV, Retaguarda, Emissores Fiscais.</p>
			</div>
		</div>     
	</div>
 <div id = "texto2" class='row'>
		<div class='col-4'>
			<div class='card1'>
				<h2>Moda</h2>
				<p>Roupas, Calçados e Acessórios. </p>
				<h6>Programas e Sistemas:</h6>
				<p>PDV, Retaguarda, Emissores Fiscais.</p>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Veiculos</h2>
				<p>Estacionamentos, Lava Rapido, Posto de Abastecimento e Conveniência.</p>
				<h6>Programas e Sistemas:</h6>
				<p>PDV, Retaguarda, Emissores Fiscais.</p>
				<p>Controlador de Estacionamento.</p>
				<p>Controlador de Lavar Rápido</p>
				<p>Controlador de Posto de Abastecimento.</p>

			</div>
		</div>
    
	</div>



</div>


	  )
	  };

export default Segmentos;
